import React from 'react';
import { Redirect } from 'react-router-dom';
import { routePaths } from '../../../../routePaths';
import WarehouseToolbar from '../WarehouseToolbar/WarehouseToolbar';
import { useWarehousesScope } from '../../providers/WarehouseScopeProvider';
import WarehouseCardAction from '../WarehouseToolbar/WarehouseCardAction';
import { WarehouseCardsTable } from './WarehouseCardsTable';
import WarehouseCardsPageWrapper from './WarehouseCardsPageWrapper';

const WarehouseCards = () => {
    const { warehouses } = useWarehousesScope();

    return warehouses.length <= 0 ?
        <Redirect to={routePaths.warehouses} />
        : (
            <>
                <WarehouseToolbar endAdorment={<WarehouseCardAction />} />
                <WarehouseCardsPageWrapper>
                    <WarehouseCardsTable />
                </WarehouseCardsPageWrapper>
            </>
        );
};

export default WarehouseCards;
